export const SolutionSlugs = [
  { solutionSlug: "contract_storage" },
  { solutionSlug: "paperless_night_audit" },
];

export default SolutionSlugs;
